import { useEffect } from "react";
import environment from "../env";

const useWebchatScript = () => {
  useEffect(() => {
    const webchatEnabled = environment.WEBCHAT_ENABLED;
    const scriptUrl = environment.CONNECT_SCRIPT_URL;
    const snippetId = environment.CONNECT_SNIPPET_ID;
    const widgetId = environment.CONNECT_WIDGET_ID;

    if (!webchatEnabled) {
      console.warn("Webchat is not enabled.");
      return;
    }

    const s = document.createElement("script");
    s.src = scriptUrl;
    s.async = 1;
    s.id = widgetId;
    document.getElementsByTagName("head")[0].appendChild(s);
    window["amazon_connect"] =
      window["amazon_connect"] ||
      function () {
        window["amazon_connect"].ac = window["amazon_connect"].ac || [];
        window["amazon_connect"].ac.push(arguments);
      };
    const amazon_connect = window["amazon_connect"];
    amazon_connect("styles", {
      iconType: "CHAT",
      openChat: { color: "#ffffff", backgroundColor: "#123456" },
      closeChat: { color: "#ffffff", backgroundColor: "#123456" },
    });
    amazon_connect("snippetId", snippetId);
    amazon_connect("supportedMessagingContentTypes", [
      "text/plain",
      "text/markdown",
      "application/vnd.amazonaws.connect.message.interactive",
      "application/vnd.amazonaws.connect.message.interactive.response",
    ]);
  }, []);
};

export default useWebchatScript;
